import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class PlanningDashboardCapacityWeeksRoute extends Route {
  @service betaToggle;

  model() {
    return this.modelFor('planning.dashboard.capacity');
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    const defaultStatus = this.betaToggle.statusOptions.map(
      (item) => item.value,
    );
    if (controller.get('statuses').length === 0) {
      controller.set('statuses', defaultStatus);
    }
  }
}

export default instrumentRoutePerformance(PlanningDashboardCapacityWeeksRoute);
